"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const enums_1 = require("../enums");
class GetReviewsQuery extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.Min)(1),
    (0, class_validator_1.Max)(10),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({ example: 8, description: 'The minimum score of the returned reviews' }),
    tslib_1.__metadata("design:type", Number)
], GetReviewsQuery.prototype, "minimumScore", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.Min)(1),
    (0, class_validator_1.Max)(20),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({ example: 6, description: 'Maximum amount of reviews to be returned' }),
    tslib_1.__metadata("design:type", Number)
], GetReviewsQuery.prototype, "amountOfReviews", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.Min)(1),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({ example: 1, description: 'The page to request.' }),
    tslib_1.__metadata("design:type", Number)
], GetReviewsQuery.prototype, "page", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsIn)(Object.values(enums_1.KlantenvertellenLocation)),
    (0, base_models_1.Docs)({
        example: 'essent',
        description: 'The location for which the reviews API should report back on. Falls back to the default brand if not provided',
    }),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], GetReviewsQuery.prototype, "location", void 0);
exports.default = GetReviewsQuery;
